import type { State } from 'shared/types/gallery/state'

export const INITIAL_STATE: State.RefinementState = {}
